@if (showSpinner) {
  <app-loader> </app-loader>
}

<div class="left-panel">
  <div class="wrap-left-panel">
    <div class="tabs">
      @for (label of mainLabels; track label) {
        <span (click)="selectFilter(label)" [class.active]="selectedFilter === label">
          {{ label | titlecase }}
        </span>
      }
    </div>

    @for (oneAnnouncement of getFilteredAnnouncements(); track oneAnnouncement) {
      <div class="card">
        @if (isExpired(oneAnnouncement)) {
          <div class="tag">
            <span class="expired-tag common-tag "><span class="red-circle circle"></span>Expired</span>
          </div>
        }
        @if (isActive(oneAnnouncement)) {
          <div class="tag">
            <span class="active-tag common-tag"><span class="green-circle circle"></span>Active</span>
          </div>
        }
        @if (isScheduled(oneAnnouncement)) {
          <div class="tag">
            <span class="scheduled-tag common-tag"><span class="blue-circle circle"></span>Scheduled</span>
          </div>
        }
        <div class="card-headers">
          <div class="profile-info">
            <div class="profile-img">
              <img [src]="oneAnnouncement.user.profile_image || '../../../assets/announcement/fakeUser.png'" alt="i" />
            </div>
            <div class="card-detail">
              <div>
                <h6 class="name">
                  {{ oneAnnouncement.user.first_name}} {{oneAnnouncement.user.last_name}} <small>
                ({{oneAnnouncement.user.description }})</small>
              </h6>
            </div>
            <div class="card-timeDate">
              <img class="calendar-icon" src="../../../assets/announcement/calendar.svg">
              <span class="card-date"> {{oneAnnouncement.start_date | date:'dd MMM yyyy'}} </span>
              <span class="line-color">|</span>
              <span class="expiry-date-color">Expiry date: {{oneAnnouncement.expiry_date | date:'dd MMM
              yyyy'}}</span>
            </div>
          </div>
        </div>
        @if (adminCheck) {
          <div class="action-icon">
            <img class="edit-icon" src="../../../assets/announcement/edit.svg"
              (click)="editAnnouncement(oneAnnouncement.id)"> <span class="line-color">|</span>
              <img class="trash-icon" src="../../../assets/announcement/trash.svg"
                (click)="idSendToModaldelete(oneAnnouncement.id)" data-toggle="modal"
                data-target="#deleteAnnouncementModal">
              </div>
            }
          </div>
          @if (oneAnnouncement.files.length > 0) {
            <div class="card-image">
              <div class="swiper announcement-swiper" [attr.id]="'swiper-' + oneAnnouncement.id">
                <div class="swiper-wrapper">
                  @for (file of oneAnnouncement.files; track file) {
                    <div class="swiper-slide">
                      @if (isImage(file)) {
                        <img [src]="file" alt="Announcement" class="media" />
                      }
                      @if (isVideo(file)) {
                        <video [src]="file" controls class="media"></video>
                      }
                    </div>
                  }
                </div>
                <!-- Scoped controls -->
                <div class="swiper-button-prev" [attr.id]="'prev-' + oneAnnouncement.id"></div>
                <div class="swiper-button-next" [attr.id]="'next-' + oneAnnouncement.id"></div>
                <div class="swiper-pagination" [attr.id]="'pagination-' + oneAnnouncement.id"></div>
              </div>
            </div>
          }
          <h6 class="detail-heading">{{oneAnnouncement.title}}</h6>
          <p class="detail-text" [innerHTML]="oneAnnouncement.description"></p>
          <!-- <div *ngIf="hasReactions(oneAnnouncement.reactionCounts)" class="card-reaction-footer see-allcase">
          <div class="see-all-emoji" *ngFor="let reaction of getReactions(oneAnnouncement.reactionCounts); let i = index"
            [style.left.px]="i * 16" [style.zIndex]="getReactions(oneAnnouncement.reactionCounts).length - i">
            <img class="emoji" [src]="getReactionImage(reaction.type)" [alt]="reaction.type" />
          </div>
          <div class="total-count">
            {{ getTotalReactionCount(oneAnnouncement.reactionCounts) }}
          </div>
        </div> -->
        <div class="card-reaction-footer">
          <div class="emoji-sections">
            <!-- Dynamic reactions -->
            @for (reaction of getReactions(oneAnnouncement.reactionCounts); track reaction) {
              <div class="reaction">
                <img class="emoji" [src]="getReactionImage(reaction.type)" [alt]="reaction.type" />
                <span class="count">{{ reaction.count }}</span>
              </div>
            }
            <!-- Add emoji section -->
            <div class="reaction like add-emoji-section">
              <img class="emoji add-emoji" src="../../../../../assets/theme1/add-emoji.svg" alt="Add Emoji" />
              <!-- Hidden emojis that show on hover -->
              <div class="emoji-list">
                @for (type of ['like','love','dislike','wow','laught','angry','upset']; track type) {
                  <img class="emoji"
                    [src]="getReactionImage(type)" [alt]="type" (click)="saveReaction(oneAnnouncement.id, type)" />
                }
              </div>
            </div>
          </div>
          <div class="info">
            <div data-toggle="modal" data-target="#emojiModal" (click)="openReactions(oneAnnouncement)">
              <img src="../../../assets/theme1/info-circle.svg" alt="info" />
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>


<div class="modal fade" id="deleteAnnouncementModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered centerModal" role="document">
    <div class="modal-content container-announceModal">

      <!-- Modal Heading -->
      <!-- <h2 class="heading-closeModal">Delete Announcement</h2> -->
      <div class="modal-body-img">
        <img src="../../../assets/theme1/warning.png" alt="" />
      </div>

      <!-- Confirmation Text -->
      <p class="mt-3 mb-3 text-center">
        Are you sure you want to delete this announcement?
      </p>

      <!-- Buttons -->
      <div class="announceModal-footer">
        <button class="cancel" data-dismiss="modal">Cancel</button>
        <button class="confirmDelete-btn" (click)="deleteAnnouncement(idSendToModal)">Delete</button>
      </div>

    </div>
  </div>
</div>

<!-- modals -->
<div class="modal fade" id="emojiModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog model-main modal-dialog-centered modal-lg" role="document">
    <div class="modal-content container-emoji">

      <h2 class="heading-reaction">Reactions</h2>

      <!-- Tabs -->
      @if (selectedAnnouncement) {
        <div class="reaction-tabs">
          <span class="tab" [class.active]="selectedTab === 'all'" (click)="selectTab('all')">
            All ({{ getReactionCount('all') }})
          </span>
          @for (type of getAvailableReactionTypes(); track type) {
            <span class="tab" [class.active]="selectedTab === type"
              (click)="selectTab(type)">
              <img class="emoji" [src]="getReactionImage(type)" [alt]="type" />
              <span class="count">{{ getReactionCount(type) }}</span>
            </span>
          }
        </div>
      }

      <!-- Reaction list -->
      <div class="reaction-list">
        @for (reaction of filteredUsers(); track reaction) {
          <div class="reaction-item">
            <div class="user-detail">
              <div class="avatar-container">
                <img class="avatar" [src]="reaction.user.profile_image" alt="avatar" />
                <div class="emoji-below">
                  <img class="emoji-img" [src]="getReactionImage(reaction.reaction)" [alt]="reaction.reaction" />
                </div>
              </div>
              <div class="user-info">
                <div class="name-in-modal">{{ reaction.user.first_name }} {{ reaction.user.last_name }}</div>
                <div class="role">{{ reaction.user.description || 'Member' }}</div>
              </div>
            </div>
            <div class="timestamp">{{ reaction.created_at | date:'dd MMM yyyy | hh:mm a' }}</div>
          </div>
        }
      </div>

    </div>
  </div>
</div>